export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("hub-pickers-lib/lang/en.lyaml"));
at({ "en": { "main": { "pageTitle": "Accounts Dashboard | HubSpot", "header": "HubSpot Accounts", "searchText": "Search accounts", "filterText": "Compare sessions:", "filterByWeek": "Week over week", "filterByMonth": "Month over month", "filterByThirtyDay": "Last 30 days" } } });
};